/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPatientProcedures } from 'app/entities/patient-procedure/patient-procedure.reducer';
import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { getEntities as getNurses } from 'app/entities/nurse/nurse.reducer';
import { getEntities as getVitals } from 'app/entities/vitals/vitals.reducer';
import { getEntities as getPreOpAnaesthesiaCharts } from 'app/entities/pre-op-anaesthesia-chart/pre-op-anaesthesia-chart.reducer';
import { OPVentilation } from 'app/shared/model/enumerations/op-ventilation.model';
import { createEntity, getEntity, reset, updateEntity } from './intra-op-chart.reducer';

export const IntraOPChartUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const patientProcedures = useAppSelector(state => state.patientProcedure.entities);
  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const doctors = useAppSelector(state => state.doctor.entities);
  const nurses = useAppSelector(state => state.nurse.entities);
  const vitals = useAppSelector(state => state.vitals.entities);
  const preOpAnaesthesiaCharts = useAppSelector(state => state.preOpAnaesthesiaChart.entities);
  const intraOPChartEntity = useAppSelector(state => state.intraOPChart.entity);
  const loading = useAppSelector(state => state.intraOPChart.loading);
  const updating = useAppSelector(state => state.intraOPChart.updating);
  const updateSuccess = useAppSelector(state => state.intraOPChart.updateSuccess);
  const oPVentilationValues = Object.keys(OPVentilation);

  const handleClose = () => {
    navigate(`/intra-op-chart${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPatientProcedures({}));
    dispatch(getGlucoUsers({}));
    dispatch(getDoctors({}));
    dispatch(getNurses({}));
    dispatch(getVitals({}));
    dispatch(getPreOpAnaesthesiaCharts({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }

    const entity = {
      ...intraOPChartEntity,
      ...values,
      surgery: patientProcedures.find(it => it.id.toString() === values.surgery?.toString()),
      patient: glucoUsers.find(it => it.id.toString() === values.patient?.toString()),
      anaesthesiologist: doctors.find(it => it.id.toString() === values.anaesthesiologist?.toString()),
      surgeon: doctors.find(it => it.id.toString() === values.surgeon?.toString()),
      nurse: nurses.find(it => it.id.toString() === values.nurse?.toString()),
      vitals: vitals.find(it => it.id.toString() === values.vitals?.toString()),
      preOpAnaesthesiaChart: preOpAnaesthesiaCharts.find(it => it.id.toString() === values.preOpAnaesthesiaChart?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          opVentilation: 'CONTOLLED',
          ...intraOPChartEntity,
          surgery: intraOPChartEntity?.surgery?.id,
          patient: intraOPChartEntity?.patient?.id,
          anaesthesiologist: intraOPChartEntity?.anaesthesiologist?.id,
          surgeon: intraOPChartEntity?.surgeon?.id,
          nurse: intraOPChartEntity?.nurse?.id,
          vitals: intraOPChartEntity?.vitals?.id,
          preOpAnaesthesiaChart: intraOPChartEntity?.preOpAnaesthesiaChart?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.intraOPChart.home.createOrEditLabel" data-cy="IntraOPChartCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.intraOPChart.home.createOrEditLabel">Create or edit a IntraOPChart</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="intra-op-chart-id"
                  label={translate('tinyMedicRestApp.intraOPChart.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPChart.oxygen')}
                id="intra-op-chart-oxygen"
                name="oxygen"
                data-cy="oxygen"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPChart.nitrousOxide')}
                id="intra-op-chart-nitrousOxide"
                name="nitrousOxide"
                data-cy="nitrousOxide"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPChart.halothane')}
                id="intra-op-chart-halothane"
                name="halothane"
                data-cy="halothane"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPChart.isoflurane')}
                id="intra-op-chart-isoflurane"
                name="isoflurane"
                data-cy="isoflurane"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPChart.sevoflurane')}
                id="intra-op-chart-sevoflurane"
                name="sevoflurane"
                data-cy="sevoflurane"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPChart.desflurane')}
                id="intra-op-chart-desflurane"
                name="desflurane"
                data-cy="desflurane"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPChart.invasiveLines')}
                id="intra-op-chart-invasiveLines"
                name="invasiveLines"
                data-cy="invasiveLines"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPChart.urineOutput')}
                id="intra-op-chart-urineOutput"
                name="urineOutput"
                data-cy="urineOutput"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPChart.bloodLoss')}
                id="intra-op-chart-bloodLoss"
                name="bloodLoss"
                data-cy="bloodLoss"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPChart.otherLosses')}
                id="intra-op-chart-otherLosses"
                name="otherLosses"
                data-cy="otherLosses"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPChart.opVentilation')}
                id="intra-op-chart-opVentilation"
                name="opVentilation"
                data-cy="opVentilation"
                type="select"
              >
                {oPVentilationValues.map(oPVentilation => (
                  <option value={oPVentilation} key={oPVentilation}>
                    {translate(`tinyMedicRestApp.OPVentilation.${oPVentilation}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPChart.active')}
                id="intra-op-chart-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPChart.cursor')}
                id="intra-op-chart-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPChart.lastupdated')}
                id="intra-op-chart-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPChart.microSec')}
                id="intra-op-chart-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPChart.timestampentry')}
                id="intra-op-chart-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="intra-op-chart-surgery"
                name="surgery"
                data-cy="surgery"
                label={translate('tinyMedicRestApp.intraOPChart.surgery')}
                type="select"
                required
              >
                <option value="" key="0" />
                {patientProcedures
                  ? patientProcedures.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="intra-op-chart-patient"
                name="patient"
                data-cy="patient"
                label={translate('tinyMedicRestApp.intraOPChart.patient')}
                type="select"
                required
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="intra-op-chart-anaesthesiologist"
                name="anaesthesiologist"
                data-cy="anaesthesiologist"
                label={translate('tinyMedicRestApp.intraOPChart.anaesthesiologist')}
                type="select"
                required
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="intra-op-chart-surgeon"
                name="surgeon"
                data-cy="surgeon"
                label={translate('tinyMedicRestApp.intraOPChart.surgeon')}
                type="select"
                required
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="intra-op-chart-nurse"
                name="nurse"
                data-cy="nurse"
                label={translate('tinyMedicRestApp.intraOPChart.nurse')}
                type="select"
              >
                <option value="" key="0" />
                {nurses
                  ? nurses.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="intra-op-chart-vitals"
                name="vitals"
                data-cy="vitals"
                label={translate('tinyMedicRestApp.intraOPChart.vitals')}
                type="select"
              >
                <option value="" key="0" />
                {vitals
                  ? vitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="intra-op-chart-preOpAnaesthesiaChart"
                name="preOpAnaesthesiaChart"
                data-cy="preOpAnaesthesiaChart"
                label={translate('tinyMedicRestApp.intraOPChart.preOpAnaesthesiaChart')}
                type="select"
                required
              >
                <option value="" key="0" />
                {preOpAnaesthesiaCharts
                  ? preOpAnaesthesiaCharts.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/intra-op-chart" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default IntraOPChartUpdate;
